<template>
  <div>
    <div v-if="hasBindData.isExistAds">
      <el-card class="card-box">
        <el-row class="btn-group mb-16" type="flex">
          <el-col :lg="12" :sm="24">
            <el-button
              class="btn-item"
              type="primary"
              @click="handleBtn('add')"
              v-auth="'stores::shop-site::google-add'"
            >
              {{ $t('shop-site::google::add_button') }}
            </el-button>
            <el-button class="btn-item" @click="handleBtn('account')" v-auth="'stores::shop-site::google-manager'">
              {{ $t('shop-site::google::addManager_button') }}
            </el-button>
            <!-- <div style="display:inline-block;">
              <i class="icon-a-01wenhao iconfont-el"></i>
              <el-button type="text" @click="toGuider">
                如何获取Facebook账号ID及Token？
              </el-button>
            </div> -->
          </el-col>
          <el-col :lg="12" :sm="24" class="right-col">
            <DictSelect
              v-model="params.shop_id"
              :popperAppendToBody="false"
              dictKey="shop_id"
              :cache="false"
              filterable
              clearable
              style="width: 150px"
              :placeholder="$t('shop-site::google::placeholder_searchShop')"
            ></DictSelect>
            <el-input
              :placeholder="$t('shop-site::google::placeholder_search')"
              style="width: 250px; margin: 0 10px"
              v-model="params.customerId"
              @keyup.native.enter="search"
              clearable
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary" @click="search">{{ $t('system::common::input_search') }}</el-button>
          </el-col>
        </el-row>
        <z-table
          ref="table"
          v-loading="loading"
          :data="tableData"
          row-key="id"
          :max-height="600"
          :columns="columns"
          :pagination.sync="pagination"
          @page-change="getListData"
        >
          <template #shopName="{ row }">
            <p class="oneline" :title="row.shopName">{{ row.shopName }}</p>
          </template>
          <template #shopIdHeader>
            <div style="text-align: center">{{ $t('shop-site::google::table_shop') }}</div>
          </template>

          <template #statusHeader>
            <div style="text-align: center">{{ $t('shop-site::google::table_status') }}</div>
          </template>
          <template #time="{ row }">
            <p>{{ $t('shop-site::google::table_creatTime') }}：{{ row.createTime }}</p>
          </template>
          <template #status="{ row }">
            <el-switch
              v-model="row.status"
              active-color="#0560fd"
              inactive-color="#E9E9E9"
              @change="val => onSwitchChange(row, val)"
            ></el-switch>
          </template>
          <template #operate="{ row }">
            <el-button
              :disabled="row.shopId === 0"
              @click="handleBtn('edit', row)"
              type="text"
              v-auth="'stores::shop-site::google-edit'"
            >
              {{ $t('shop-site::google::table_edit') }}
            </el-button>
          </template>
        </z-table>
      </el-card>
    </div>
    <div v-else>
      <emptyCard
        :data="{
          title: $t('shop-site::empty::ad_title'),
          img: require('@/assets/images/emptyDefault/Marketingaccount@2x.png'),
          desc: $t('shop-site::empty::ad_google_tips'),
          buttons: [
            {
              click: onBindSetting,
              text: $t('shop-site::empty::ad_bind_google'),
              auth: 'stores::shop-site::google-add',
            },
            {
              click: onBindGoogle,
              text: $t('shop-site::google::addManager_button'),
              auth: 'stores::shop-site::google-manager',
            },
          ],
        }"
      ></emptyCard>
    </div>
    <managerModal v-model="accountVisable" :drawRow="drawRow"></managerModal>
    <editModal v-model="editVisable" :drawRow="drawRow" @save="onSave"></editModal>
  </div>
</template>
<script>
import managerModal from './components/manager-modal'
import editModal from './components/google-modal'
import DictSelect from '@/components/dict-select'
import { getGoogleList, setGoogleAccountStatus, getGoogleCallback } from '@/server/marketing.js'

export default {
  components: {
    managerModal,
    editModal,
    DictSelect,
  },
  data() {
    return {
      params: {
        customerId: '',
        shop_id: '',
      },
      shopIds: [],
      accountVisable: false,
      editVisable: false,
      drawRow: {
        type: 'write',
        item: {},
      },
      columns: [
        {
          prop: 'index',
          label: this.$t('shop-site::google::table_no'),
          fixed: 'left',
          minWidth: '50',
        },
        {
          prop: 'shopName',
          label: this.$t('shop-site::google::table_shop'),
          slotHeaderName: 'shopIdHeader',
          showOverflowTooltip: true,
          minWidth: '150',
        },
        {
          prop: 'accountCustomerId',
          label: this.$t('shop-site::google::table_manager'),
          showOverflowTooltip: true,
          width: '200',
        },
        {
          prop: 'customerId',
          label: this.$t('shop-site::google::table_child'),
          showOverflowTooltip: true,
          width: '200',
        },
        {
          prop: 'status',
          label: this.$t('shop-site::google::table_status'),
          slotHeaderName: 'statusHeader',
          width: '160',
          align: 'center',
        },

        {
          prop: 'operate',
          slotHeaderName: 'operateHeader',
          label: this.$t('shop-site::google::table_handle'),
          width: '120',
          fixed: 'right',
        },
      ],
      tableData: [],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0,
      },
      loading: false,
    }
  },
  async mounted() {
    this.init({})
    this.addManager()
  },
  methods: {
    async addManager() {
      if (this.$route.query.state) {
        const { data } = await getGoogleCallback({
          state: this.$route.query.state || null,
          code: this.$route.query.code || null,
          error: this.$route.query.error || null,
        })
        if (data.code === this.$code) {
          this.$message.success(this.$t('system::tip::control_success'))
        }
        this.$router.push({
          query: {
            type: 3,
          },
        })
      }
    },
    onBindSetting() {
      this.handleBtn('add')
    },
    onBindGoogle() {
      this.handleBtn('account')
    },
    toGuider() {
      window.open('https://docs.qq.com/doc/DRnBjbEJsZFZpY3Z6', '_blank')
    },
    async onSwitchChange(row, status) {
      if (!status) {
        this.$confirm('关闭账号后将不再拉取广告数据，确定要继续关闭账号吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
          .then(() => {
            this.changeAccountAdsStatus(row, status)
          })
          .catch(() => {
            row.status = true
          })
      } else {
        this.changeAccountAdsStatus(row, status)
      }
    },
    async changeAccountAdsStatus(row, status) {
      this.loading = true
      const { data } = await setGoogleAccountStatus({ id: row.id, status: Number(status) })
      this.loading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
        this.getListData(this.params)
      }
    },
    handleBtn(type, row) {
      this.drawRow.type = type
      if (row) {
        this.drawRow.item = row
      }
      if (type === 'account') {
        this.accountVisable = true
      } else if (type === 'add' || type === 'edit') {
        this.editVisable = true
      }
    },
    async onSave() {
      this.params = {
        customerId: '',
        shop_id: '',
      }
      this.getListData({}, true)
      if (!this.hasBindData.isExistAds) await this.$store.dispatch('getBindData')
    },
    init(params) {
      this.getListData(params || {}, true)
    },
    search() {
      this.getListData(this.params)
    },
    async getListData(params, init = false) {
      if (init) {
        // 回到第一页
        this.pagination.pageNum = 1
      }
      // if (!params) {
      //   params = this.params
      // }
      this.loading = true
      const { data } = await getGoogleList({
        ...params,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      })
      this.loading = false

      if (data.code === this.$code) {
        this.tableData = data.data.items.map((item, index) => {
          return {
            index: (this.pagination.pageNum - 1) * this.pagination.pageSize + (index + 1),
            ...item,
            status: Boolean(item.status),
          }
        })
        this.pagination.total = data.data.totalCount
      }
    },
  },
  watch: {
    tableData(val, oldVal) {
      if (val.length === 0 && val.length !== oldVal.length) {
        this.$store.dispatch('getBindData')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-group {
  margin-bottom: 10px;

  .btn-item {
    margin-left: 0;
    margin-right: 10px;
  }
}
.oneline {
  overflow: hidden;
  vertical-align: middle;
  max-width: 100%;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep {
  .el-tag__close {
    color: #fff;
    &:hover {
      background-color: inherit;
    }
  }
}
.icon-a-01wenhao {
  font-size: 14px;
  margin: 0 5px;
}
</style>
